import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SiteProvider } from "@/lib/SiteContext";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingSocial from "@/components/layout/FloatingSocial";
import HomePage from "@/pages/HomePage";
import { ProductsListPage, ProductDetail } from "@/pages/ProductsPage";
import AboutPage from "@/pages/AboutPage";
import CatalogPage from "@/pages/CatalogPage";
import ContactPage from "@/pages/ContactPage";
import AdminPage from "@/pages/AdminPage";
import CheckoutPage from "@/pages/CheckoutPage"; // Yeni: Ödeme Sayfası
import Legal from '@/pages/Legal';

import Lenis from 'lenis';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <FloatingSocial />
      {children}
      <Footer />
    </>
  );
}

function App() {
  // --- OPTİMİZASYON: Lenis Motoru Gelişmiş Ayarlar ---
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1.1,
      touchMultiplier: 1.5,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }

    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <SiteProvider>
        <ScrollToTop />
        {/* CustomCursor bileşeni tamamen kaldırıldı. Default tarayıcı imleci aktif. */}
        <Routes>
          {/* Admin Paneli */}
          <Route path="/admin" element={<AdminPage />} />

          {/* Ana Sayfalar */}
          <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
          <Route path="/urunler" element={<PublicLayout><ProductsListPage /></PublicLayout>} />
          <Route path="/urunler/:id" element={<PublicLayout><ProductDetail /></PublicLayout>} />
          <Route path="/hakkimizda" element={<PublicLayout><AboutPage /></PublicLayout>} />
          <Route path="/katalog" element={<PublicLayout><CatalogPage /></PublicLayout>} />
          <Route path="/iletisim" element={<PublicLayout><ContactPage /></PublicLayout>} />
          
          {/* Ödeme Süreci */}
          <Route path="/odeme" element={<PublicLayout><CheckoutPage /></PublicLayout>} />
          <Route path="/yasal-metinler" element={<Legal />} />
        </Routes>
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;